import { useMemo } from 'react';

interface ICountDownReturn {
  clearCountDown: () => void;
  startCountDown: (onInterval: () => void) => void;
}

const useCountDown = (): ICountDownReturn => {
  const { startCountDown, clearCountDown } = useMemo(() => {
    let timerId: undefined | number = undefined;

    const clear = (): void => {
      clearInterval(timerId);
      timerId = undefined;
    };

    const start = (onInterval: () => void): void => {
      clearCountDown();
      timerId = window.setInterval(onInterval, 1000);
    };

    return {
      clearCountDown: clear,
      startCountDown: start,
    };
  }, []);

  return { startCountDown, clearCountDown };
};

export default useCountDown;
